var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 34,
    fill: "none",
    viewBox: "0 0 33 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M7.37811 19.3897C7.77608 18.6601 8.82372 18.6601 9.22169 19.3897L15.8529 31.547C16.2346 32.2467 15.7281 33.0998 14.9311 33.0998H1.66867C0.871659 33.0998 0.36523 32.2467 0.746881 31.547L7.37811 19.3897Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M1.2998 2.9999C1.2998 1.8401 2.24001 0.899902 3.39981 0.899902H13.1998C14.3596 0.899902 15.2998 1.8401 15.2998 2.9999V12.7999C15.2998 13.9597 14.3596 14.8999 13.1998 14.8999H3.3998C2.24001 14.8999 1.2998 13.9597 1.2998 12.7999V2.9999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M18.7998 21.1999C18.7998 20.0401 19.74 19.0999 20.8998 19.0999H30.6998C31.8596 19.0999 32.7998 20.0401 32.7998 21.1999V30.9999C32.7998 32.1597 31.8596 33.0999 30.6998 33.0999H20.8998C19.74 33.0999 18.7998 32.1597 18.7998 30.9999V21.1999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M32.7998 7.8999C32.7998 11.7659 29.6658 14.8999 25.7998 14.8999C21.9338 14.8999 18.7998 11.7659 18.7998 7.8999C18.7998 4.03391 21.9338 0.899902 25.7998 0.899902C29.6658 0.899902 32.7998 4.03391 32.7998 7.8999Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon (4).bf2116953ad91d9a5bb2c6bdb7386dfd.svg";
export { ForwardRef as ReactComponent };